<template>
  <section class="app-main">
    <!--    <router-view v-slot="{ Component }" :key="$route.path">-->
    <!--      <transition name="fade" mode="out-in">-->
    <!--        <keep-alive :include="cachedViews">-->
    <!--          <component :is="Component" />-->
    <!--        </keep-alive>-->
    <!--      </transition>-->
    <!--    </router-view>-->
    <router-view />
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      // return this.$store.state.tagsView.cachedViews
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  //min-height: calc(100vh - 50px);
  //width: 100%;
  //position: relative;
  //top: 50px;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
